export default "__VITE_ASSET__BRvA_fYZ__"